import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Col, Dropdown, Row } from 'react-bootstrap';
import columnFilter from '../../assets/images/CustomerManagement/columnFilter.svg'
import valueFilter from '../../assets/images/CustomerManagement/valueFilter.svg'
import '../../assets/css/dashboard.scss'
import '../../assets/css/customermanagement.scss'
import 'react-datepicker/dist/react-datepicker.css';
import { SbAddBtn, SbFilterBtn } from '../Buttons/Buttons';
import Select from 'react-select';
import Download from '../MainSection/Download/Download';
import SbDropdownButton from '../Buttons/SbDropdownButton';
import AddVendorMaster from './AddVendorMaster';
import VendorMasterTable from './VendorMasterTable';
import ViewVendorMasterModal from './ViewVendorMasterModal';
import VendorMasterBulkUploadModal from './VendorMasterBulkUploadModal';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { loadSingleVendorMasterDatas, loadVendorMasterDatas } from '../../redux/action';

const VendorMaster = () => {

    let dispatch = useDispatch();
    let location = useLocation();
    const { vendorMasterData, totalDataCount, singleVendorMasterData } = useSelector((state) => state.data);
    console.log(singleVendorMasterData, 'singleVendorMasterData')
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const storedModulePermissions = JSON.parse(sessionStorage.getItem("modulePermissions")) || [];

    const [moduleData, setModuleData] = useState(null);

    // **Get moduleId from `location.state`**
    const moduleId = location.state?.moduleId;

    useEffect(() => {
        if (moduleId && storedModulePermissions.length) {
            // Find the module data using the moduleId
            const module = storedModulePermissions.find((m) => m.Modules_IDPK === moduleId);
            setModuleData(module);
        }
    }, [storedModulePermissions, moduleId]);

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showFilterMenu, setShowFilterMenu] = useState(false);
    const [showColumnFilterModal, setShowColumnFilterModal] = useState(false);
    const [showValueFilterModal, setShowValueFilterModal] = useState(false);
    const [showViewDetails, setShowViewDetails] = useState(false);
    const [businessUnitModal, setBusinessUnitModal] = useState(false);
    const [branchPlantModal, setBranchPlantModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(true);

    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState('');

    const [selectedColumns, setSelectedColumns] = useState([
        "VENDOR CODE", "VENDOR NAME", "COMPANY NAME", "CITY", "STATE / REGION",
        "ZIPCODE", "VENDOR ACCOUNT GROUP", "DELETION FLAG", "CENTRAL DELETION FLAG", "CENTRAL POSTING BLOCK", "CENTRAL PURCHASE BLOCK", "REGION", "COUNTRY CODE", "SUPPLIER", "MAINTENANCE", "MANUFACTURER", "STATUS", "ACTION"
    ]);

    const [excelDownloadRequested, setExcelDownloadRequested] = useState(false);
    const [pdfDownloadRequested, setPdfDownloadRequested] = useState(false);
    const [wordDownloadRequested, setWordDownloadRequested] = useState(false);
    const [printDownloadRequested, setPrintDownloadRequested] = useState(false);
    const [imageDownloadRequested, setImageDownloadRequested] = useState(false);

    const [vendorID, setVendorID] = useState("");

    // Add a new state for downloading
    const [isDownloading, setIsDownloading] = useState(false);

    const vendorMasterDatas = () => {
        dispatch(loadVendorMasterDatas(setLoading, rowsPerPage, page + 1, searchQuery));
    }
    useEffect(() => {
        vendorMasterDatas();
    }, [page, rowsPerPage, searchQuery]);

    const toggleFilterMenu = () => {
        setShowFilterMenu(!showFilterMenu);
    };

    const handleFromDateChange = (date) => {
        setFromDate(date);
    };

    const handleToDateChange = (date) => {
        setToDate(date);
    };
    const handleOpenModal = (vendorId) => {
        setIsModalOpen(true);
        if (vendorId) {
            dispatch(loadSingleVendorMasterDatas(vendorId));
            setVendorID(vendorId);
        } else {
            setVendorID("");
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleOpenColumnFilterModal = () => {
        setShowFilterMenu(false);
        setShowColumnFilterModal(true);
    };

    const handleCloseColumnFilterModal = () => {
        setShowColumnFilterModal(false);
    };
    const handleOpenValueFilterModal = () => {
        setShowFilterMenu(false);
        setShowValueFilterModal(true);
    };

    const handleCloseValueFilterModal = () => {
        setShowValueFilterModal(false);
    };

    const handleOpenViewModal = () => {
        setShowViewDetails(!showViewDetails);
    }

    const handleCloseViewModal = () => {
        setShowViewDetails(false)
    }

    const handleOpenBulkUploadModal = () => {
        setShowBulkUploadModal(true);
    };
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
    };

    return (
        <div className="customer-management-container">
            <Main>
                <div className='components-download-container'>
                    <Download
                        showBackButton={true}
                        moduleName="Back"
                    />
                </div>
                <div className='customermanagement-content-container'>
                    <div className="customermanagement-content">
                        <Row className='customermanagement-btns-container'>
                            <Col md={3} className='customermanagement-backbtn-div'>
                                {/* <img src={backbtn} alt="" /> */}
                                <span>Vendor Master</span>
                            </Col>
                            <Col md={9} className='customermanagement-search-filter'>
                                <div className='customermanagement-header-btns filter-btn'>
                                    <SbFilterBtn btnName="Filters" onClickEffect={toggleFilterMenu} />
                                    {showFilterMenu && (
                                        <Dropdown.Menu show className='filter-dropdown-options'>
                                            <Dropdown.Item onClick={handleOpenColumnFilterModal}>
                                                <img src={columnFilter} alt="" />&nbsp;&nbsp;
                                                Column Filter
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={handleOpenValueFilterModal}>
                                                <img src={valueFilter} alt="" />&nbsp;&nbsp;
                                                Value Filter
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    )}
                                </div>
                                {/* <Col md={3}>
                                    <Select
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        placeholder="Search Status"
                                        // options={statusOptions}
                                        style={{ width: "100%" }}
                                    />
                                </Col> */}
                                <SbDropdownButton
                                    // pageName="Zone Master"
                                    btnName="Add"
                                    openAddModal={() => { handleOpenModal("") }}
                                    addBulkModel={handleOpenBulkUploadModal}
                                />
                            </Col>
                        </Row>
                        <div className='customermanagement-table-div'>
                            <VendorMasterTable
                                handleOpenModal={handleOpenModal}
                                handleOpenViewModal={handleOpenViewModal}
                                loading={loading}
                                page={page}
                                setPage={setPage}
                                rowsPerPage={rowsPerPage}
                                setRowsPerPage={setRowsPerPage}
                                moduleData={moduleData}
                                totalDataCount={totalDataCount}
                                selectedColumns={selectedColumns}
                                isDownloading={isDownloading}
                                vendorMasterData={vendorMasterData}
                            />
                        </div>
                    </div>
                </div>
            </Main>
            {
                isModalOpen && <AddVendorMaster
                    open={isModalOpen}
                    handleCloseModal={handleCloseModal}
                    vendorID={vendorID}
                    singleVendorMasterData={singleVendorMasterData}
                    vendorMasterDatas={vendorMasterDatas}
                />
            }
            {
                showBulkUploadModal && <VendorMasterBulkUploadModal
                    showBulkUploadModal={showBulkUploadModal}
                    handleCloseBulkUploadModal={handleCloseBulkUploadModal}
                // deptData={deptData}
                />
            }
            {/* {showColumnFilterModal && (
                <CustomerFilterModal
                    showColumnFilterModal={showColumnFilterModal}
                    handleCloseColumnFilterModal={handleCloseColumnFilterModal}
                />
            )}
            {showValueFilterModal && (
                <CustomerValueFilterModal
                    showValueFilterModal={showValueFilterModal}
                    handleCloseValueFilterModal={handleCloseValueFilterModal}
                />
            )} */}
            {showViewDetails && (
                <ViewVendorMasterModal
                    showViewDetails={showViewDetails}
                    handleCloseViewModal={handleCloseViewModal}
                />
            )}
        </div >
    );
};

export default VendorMaster;